import React from 'react'
import "./Homepage.css";

const FooterHomeStripe = () => {
  return (
    <>
      <div className='footerToHide' style={{ background: "linear-gradient(30.48deg, rgba(0, 55, 255, 0.22) -51.32%, rgba(113, 11, 255, 0.7) 18.85%)", fontFamily: 'Inter', fontSize: '15px', fontWeight: '400', display: 'none' }}>
        <div className="mx-4 py-3">
          <span style={{ color: '#ffffff' }}>© 2022 Bit Happier Inc, All Rights Reserved​ </span>
        </div>
      </div>
    </>
  )
}

export default FooterHomeStripe